export const unselect = Symbol('unselect');
export type Unselect = typeof unselect;
